<script lang="ts">
    import HtmlTitleView from "../../component/common/Html/HtmlTitleView.svelte";
    import AppListView from "./App/AppListView.svelte";
    import LabelValueView from "../../component/common/Value/LabelValueView.svelte";
    import ImageView from "../../component/common/Image/ImageView.svelte";
    import {ValueUtil} from "../../lib/Common/Value/ValueUtil";
    import TipsMessageAreaView from "../../component/common/Message/TipsMessageAreaView.svelte";
    import {SpaceUserTable} from "../../lib/Table/SpaceUserTable";
    import SpaceManageView from "./Manage/SpaceManageView.svelte";
    import SpaceLoadView from "../../component/Space/SpaceLoadView.svelte";


    export let params = {};


    $: pageTitle = (() => {
        if (space == null) {
            return 'スペース';
        } else {
            return space.name;
        }
    })();


    let space = null;
    let hasManagerRoll = false;

    let apps = null;
    let isLoading = false;
    let editData = null;
    let isShowSettingDialog = false;

    function onLoadSpace(event) {
        space = event.detail.space;


    }


</script>

<HtmlTitleView pageTitle={pageTitle}/>

<div class="space-page standard-page">
    <SpaceLoadView spaceUniqueId={params['space_unique_id']}
                   on:load={onLoadSpace}
                   isShowNotFoundMessage={true}
    >


        <div class="space-area">


            <div class="name-area">
                <div class="logo-title-area">
                    <span class="logo-title">
                        {#if space.icon_s3_url != null}
                            <ImageView src={space.icon_s3_url} alt={space.name}/>
                        {:else}
                            { space.name }
                        {/if}

                    </span>


                </div>


            </div>
            <div>
                <LabelValueView label="スペースID" value={space.id}/>
            </div>


        </div>

        {#if !ValueUtil.isEmpty(space.description) }
            <div>
                <TipsMessageAreaView>
                    { space.description }
                </TipsMessageAreaView>
            </div>
        {/if}


        <div class="app-area">
            <h2>アプリ一覧</h2>

            <div class="apps">
                <AppListView space={space}/>


            </div>
        </div>

        {#if SpaceUserTable.AuthorityType.hasManage(space.most_strong_authority_type)}
            <div class="space-manage-area">
                <SpaceManageView space={space}/>

            </div>
        {/if}
    </SpaceLoadView>


</div>


<style lang="scss">

    .space-page {


        .space-area {
            .name-area {
                height: 60px;
                display: flex;
                align-items: center;

                .logo-title-area {
                    flex-grow: 1;

                    .logo-title {
                        max-width: 200px;
                        height: 100%;
                        font-size: 32px;
                    }

                    .setting-button {
                        margin-left: 30px;
                        //font-size: 0.5em;
                        border-style: solid;
                        border-width: 1px;
                        border-radius: 0.25em;
                        border-color: #0003;
                        padding-left: 0.5em;
                        padding-right: 0.5em;

                    }

                }

                .secret-key-qr-code-area {
                    font-size: 0.5em;
                }

            }


        }

        .app-area {
            margin-top: 60px;

            .apps {

            }

        }

        .space-manage-area {
            margin-top: 60px;
        }

    }
</style>